import {callApi} from '@/lib/api/callApi';

/**
 * 取得比賽列表與搜尋比賽列表
 * @param {Object} params 要篩選的資料
 * @returns {Promise} promise
 */
async function getOrders(params) {
  const res = await callApi({
    category: 'order',
    apiName: '',
    method: 'get',
    params,
    defaultError: null,
  });
  return res.data;
}

export default {
  getOrders,
};
